<script>
import { isSelectedEventGroupLocked } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { commitHistory } from "@app/store/historyStore.svelte.js";
import { toast } from "@zerodevx/svelte-toast";
import * as m from "@app/paraglide/messages.js";

/** @type {{ row: any, column: any, api?: any }} */
let { row, column } = $props();

let checked = $derived(
    row?.[column?.id] === true || row?.[column?.id] === "true",
);

let ariaLabel = $derived(
    column?.id === "replyCheck"
        ? m.editor_table_column_reply_check()
        : m.editor_table_column_notes_check(),
);

/**
 * @param {Event} e
 */
function onChange(e) {
    e.stopPropagation();

    if (isSelectedEventGroupLocked()) {
        /** @type {HTMLInputElement} */ (e.currentTarget).checked = checked;
        toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
        return;
    }

    const egIdx = projectState.selected;
    const eventId = row?.id;
    if (eventId == null || egIdx == null || !column?.id) {
        /** @type {HTMLInputElement} */ (e.currentTarget).checked = checked;
        return;
    }

    const nextChecked = /** @type {HTMLInputElement} */ (e.currentTarget).checked;

    commitHistory({
        name:
            column.id === "replyCheck"
                ? "update reply check"
                : "update notes check",
        eventGroup: egIdx,
        mutate: {
            eventGroupState: (draft) => {
                const idx = draft[egIdx].events.findIndex((e) => e.id === eventId);
                if (idx < 0) return;
                draft[egIdx].events[idx][column.id] = nextChecked;
                if (!draft[egIdx].selected.includes(idx)) {
                    draft[egIdx].selected = [idx];
                }
            },
        },
    });
}
</script>

<div class="check-cell">
    <div class="form-check m-0">
        <input
            type="checkbox"
            class="form-check-input m-0"
            checked={checked}
            aria-label={ariaLabel}
            onchange={onChange}
            onclick={(e) => e.stopPropagation()}
        />
    </div>
</div>

<style>
.check-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}
.check-cell :global(.form-check) {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
    padding-left: 0;
}
.check-cell :global(.form-check-input) {
    float: none;
    margin-top: 0;
    cursor: pointer;
}
</style>
